import { render } from "./ResidentPortalSessionLink.vue?vue&type=template&id=86003c3a&scoped=true"
import script from "./ResidentPortalSessionLink.vue?vue&type=script&lang=js"
export * from "./ResidentPortalSessionLink.vue?vue&type=script&lang=js"

import "./ResidentPortalSessionLink.vue?vue&type=style&index=0&id=86003c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86003c3a"]])

export default __exports__